import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import RevolutionizeImg from "../../../images/location_new/fold7/game-sky.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Game Development in UK?</h2>
            <p>
              TekRevol is a bespoke game development company in UK that
              collaborates dedicatedly to craft exceptional gaming experiences.
              Our UK-based game developers are the powerhouse of creativity and
              technical expertise, combining their passion for gaming with
              cutting-edge skills to deliver unparalleled gaming experiences.
              When you choose TekRevol, you're tapping into a wealth of
              expertise that understands the complexities of game development.
              As a game-changing{" "}
              <Link
                to="/uk/game-development-company-london"
                rel="noopener"
                aria-label="TekRevol"
              >
                mobile game development company in UK
              </Link>
              , we understand that every game is unique. That’s why our game
              development team utilizes a personalized approach to ensure that
              your game reflects your vision and goals. Moreover, TekRevol is
              committed to using cutting-edge tools and technologies to create
              games that not only meet but exceed industry standards. Your game
              will benefit from our commitment to setting trends rather than
              merely following them. Your satisfaction is our top priority, and
              we place great value on your input and concerns. This enables us
              to develop an app that aligns seamlessly with your business
              objectives.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="game-development-in-london"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
